import { recordMap } from 'blocks/woot_woot/string_map';
import {
  anInlineSection,
  aPage,
  aProject,
  aReferenceSection,
  aSection,
} from './model';

export const DEFAULT_HOMEPAGE_MIDDLE_SECTIONS = [
  anInlineSection({
    name: 'Hero Header Section',
    description: 'Describe the product or service',
  }),
  anInlineSection({
    name: 'How It Works Section',
    description: 'Describe how the product or service works',
  }),
  anInlineSection({
    name: 'Feature Section',
    description: 'Describe main feature and its benefits',
  }),
  anInlineSection({
    name: 'CTA Section',
    description: 'Invite visitor to try your product',
  }),
  anInlineSection({
    name: 'Blog List Section',
    description: 'Resources that create value for customers',
  }),
];

export const EMPTY_PROJECT = aProject({});

export const OLD_DEFAULT_PROJECT_WITHOUT_GLOBALS = aProject({
  homePage: aPage({
    name: 'Home',
    sections: [
      anInlineSection({ name: 'Navbar' }),
      ...DEFAULT_HOMEPAGE_MIDDLE_SECTIONS,
      anInlineSection({ name: 'Footer' }),
    ],
    subPages: [aPage({ name: 'Page 2' }), aPage({ name: 'Page 3' })],
  }),
});

export const OLD_DEFAULT_PROJECT_WITH_GLOBALS = aProject({
  homePage: aPage({
    name: 'Home',
    sections: [
      aReferenceSection({ id: 'default-navbar' }),
      ...DEFAULT_HOMEPAGE_MIDDLE_SECTIONS,
      aReferenceSection({ id: 'default-footer' }),
    ],
    subPages: [aPage({ name: 'Page 2' }), aPage({ name: 'Page 3' })],
  }),
  globalSections: recordMap([
    ['default-navbar', aSection({ name: 'Navbar' })],
    ['default-footer', aSection({ name: 'Footer' })],
  ]),
});
